export default "__VITE_ASSET__DT0iv_C3__"